import Modal from "./Modal";
import ImageForm from "./ImageForm";
import { useNavigate } from 'react-router-dom';
import {useMediaQuery} from "react-responsive";
import {useState} from "react";
import {ClipLoader} from "react-spinners";
import {Ajax} from "../Service/ajax";
export default function CardLage({title, subtitle, type, enlOp, enlInfo, enlSub, nbOp, nbInfo, trf}){
    const isSmallScreen = useMediaQuery({ maxWidth: 575 });
    const navigate = useNavigate();
    const [copyStatus, setCopyStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleRedirect = () => {
        navigate("/organisation");
    };
    let component;
    const currentOrigin = window.location.origin;

    const copyToClipboard = async (trf_id) => {
        if (sessionStorage.getItem("application")) {
            const { pageUrl,id } = JSON.parse(sessionStorage.getItem("application"));
            const linkToCopy = `${currentOrigin}/${pageUrl}`;

            setIsLoading(true);

            try {
                // Appel de la logique handleSubscription
                if (trf_id) {
                    await Ajax.putRequest(`/api/v1/sub/application/update/current-plan/${id}?plan_id=${trf_id}`);
                }

                // Logique de copie dans le presse-papiers
                await navigator.clipboard.writeText(linkToCopy);
                setIsLoading(false);
                setCopyStatus("success");
                setTimeout(() => {
                    setCopyStatus("");
                }, 2000);
            } catch (error) {
                console.log(error.message);
                setIsLoading(false);
                setCopyStatus("error");
                setTimeout(() => {
                    setCopyStatus("");
                }, 2000);
            }
        }
    };


    if(type === "general"){
        component=<div className={"row"}>
            <div className={"col-lg-3 col-md-6 col-sm-9 mt-2 order-0"}>
                <Modal title={"Création d'une application"} type={"app"}
                       btnTitle={"créer application"} id={"appModal"} btnStyle={"normal"}/>
            </div>
        </div>;
            }else if(type === "particular"){
        component="";
    }else{
        component= <div className={"row"}>

            <div className="col-lg-2 col-md-6 col-sm-9 mt-2 order-0">
                <Modal title={"Modifier les informations de l'organisation"} type={"editCompany"}
                       btnTitle={"Modifier"} id={"editCompanyModal"} btnStyle={"normal"} enable={enlInfo} nb={nbInfo}/>

            </div>
            <div className="col-lg-2 col-md-6 col-sm-9 mt-2 order-0">
                <ImageForm />
            </div>
            <div className="col-lg-2 col-md-6 col-sm-9 mt-2 order-0">
                <Modal title={"Gestion d'equipe"} type={"team"}
                       btnTitle={"Equipe"} id={"teamModal"} btnStyle={"normal"} enable={enlInfo} nb={nbInfo}/>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-9 mt-2 order-0">
                <button className="btn btn-sm btn-outline-netikash w-100" style={{minWidth: "100px" }} onClick={()=>navigate("/report")}>
                    <i className="bx bx-bar-chart-alt me-2"></i> Rapport
                </button>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-9 mt-2 order-0">
                <button
                    className="btn btn-sm btn-outline-netikash w-100 d-flex align-items-center justify-content-center"
                    onClick={() => copyToClipboard(trf.id)}
                    style={{
                        minWidth: "120px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <ClipLoader color="#36d7b7" size={20} />
                    ) : copyStatus === "success" ? (
                        <i className="bx bx-check text-success me-1"></i>
                    ) : copyStatus === "error" ? (
                        <i className="bx bx-x text-danger me-1"></i>
                    ) : (
                        <i className="bx bx-link-alt me-1"></i>
                    )}
                    {isLoading
                        ? "Copie..."
                        : copyStatus === "success"
                            ? "Lien copié !"
                            : copyStatus === "error"
                                ? "Échec"
                                : "Copier le lien"}
                </button>

            </div>
        </div>
    }
    return (
        <div className="mb-4 order-0">
            <div className="card">
                <div className="d-flex align-items-end row">
                    <div className="col-sm-12">
                        <div className="card-body">
                            <div className={"row justify-content-center align-items-center"}>
                                {type !== "particular" &&
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-netikash" onClick={handleRedirect}><i
                                            className='bx bx-arrow-back'></i>{isSmallScreen ? "": "organisation"}
                                        </button>
                                    </div>
                                }
                                <div className="col">
                                    <h5 className="card-title text-netikash">
                                        {title}
                                    </h5>
                                </div>
                            </div>

                            <p className="mb-1 mt-2">
                                {subtitle}
                            </p>
                            {component}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}